/* HOOPLUME — defer decorative videos, respect visitor preferences, retain manual playback. */
(function () {
  'use strict';

  var videos = document.querySelectorAll('video[data-lazy-video], video[data-th-video]');
  if (!videos.length) return;

  var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var states = [];
  var playIcon = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
  var pauseIcon = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 5h4v14H6zm8 0h4v14h-4z" fill="currentColor"/></svg>';

  function prefersManual() {
    return !!((motion && motion.matches) || (connection && (connection.saveData || /^(slow-)?2g$/.test(connection.effectiveType || ''))));
  }

  function canRun(state) {
    return !document.hidden && state.visible && !state.userPaused && (!prefersManual() || state.userStarted);
  }

  function updateButton(state) {
    var playing = !state.video.paused && !state.video.ended;
    state.shell.classList.toggle('tl-video-playing', playing);
    state.button.innerHTML = (playing ? pauseIcon : playIcon) + '<span>' + (playing ? 'Pause' : 'Play video') + '</span>';
    state.button.setAttribute('aria-label', (playing ? 'Pause video: ' : 'Play video: ') + state.label);
  }

  function prepare(state) {
    if (state.prepared) return;
    state.prepared = true;
    state.video.preload = 'auto';
    state.video.load();
  }

  function pause(state) {
    state.requestId += 1;
    state.retryAfterPending = false;
    if (!state.video.paused) state.video.pause();
    updateButton(state);
  }

  function play(state) {
    if (!canRun(state)) return;
    if (state.pending) {
      // A new visible/manual request can arrive before a cancelled play() settles.
      // Queue only that new request; an ordinary autoplay rejection must not retry itself.
      if (state.requestId !== state.pendingRequest) state.retryAfterPending = true;
      return;
    }
    if (!state.video.paused) return;
    state.retryAfterPending = false;
    prepare(state);
    var requestId = ++state.requestId;
    var result;
    try { result = state.video.play(); }
    catch (error) { updateButton(state); return; }
    if (result && typeof result.then === 'function') {
      state.pending = true;
      state.pendingRequest = requestId;
      result.then(function () {
        var retry = state.retryAfterPending && requestId !== state.requestId && canRun(state);
        state.pending = false;
        state.retryAfterPending = false;
        if (requestId !== state.requestId || !canRun(state)) pause(state);
        else updateButton(state);
        if (retry) play(state);
      }).catch(function () {
        var retry = state.retryAfterPending && requestId !== state.requestId && canRun(state);
        state.pending = false;
        state.retryAfterPending = false;
        updateButton(state);
        if (retry) play(state);
      });
    }
  }

  videos.forEach(function (video) {
    if (video.dataset.videoEnhanced === 'true') return;
    video.dataset.videoEnhanced = 'true';
    video.muted = true;
    video.playsInline = true;

    var shell = document.createElement('div');
    shell.className = 'tl-video-shell';
    video.parentNode.insertBefore(shell, video);
    shell.appendChild(video);
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'tl-video-toggle';
    shell.appendChild(button);
    video.controls = false;
    var state = {
      video: video, shell: shell, button: button,
      label: video.getAttribute('aria-label') || 'Product demonstration',
      visible: false, near: false, prepared: false,
      userPaused: false, userStarted: false, pending: false, requestId: 0,
      pendingRequest: 0, retryAfterPending: false
    };
    states.push(state);
    button.addEventListener('click', function () {
      if (!video.paused || state.pending) {
        state.userPaused = true;
        pause(state);
      } else {
        state.userPaused = false;
        state.userStarted = true;
        state.visible = true;
        play(state);
      }
    });
    video.addEventListener('play', function () { updateButton(state); });
    video.addEventListener('pause', function () { updateButton(state); });
    video.addEventListener('error', function () {
      // Keep the poster and allow a manual retry after a temporary connection failure.
      state.prepared = false;
      updateButton(state);
    });
    updateButton(state);
  });

  if (!states.length) return;

  function syncPreferences() {
    states.forEach(function (state) {
      if (!canRun(state)) pause(state);
      else play(state);
      if (!document.hidden && state.near && !prefersManual()) prepare(state);
    });
  }

  if ('IntersectionObserver' in window) {
    var nearObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = states.find(function (candidate) { return candidate.video === entry.target; });
        state.near = entry.isIntersecting;
        if (!document.hidden && state.near && !prefersManual()) prepare(state);
      });
    }, { rootMargin: '300px 0px' });
    var visibleObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = states.find(function (candidate) { return candidate.video === entry.target; });
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
        if (canRun(state)) play(state);
        else pause(state);
      });
    }, { threshold: [0, 0.15] });
    states.forEach(function (state) {
      nearObserver.observe(state.video);
      visibleObserver.observe(state.video);
    });
  } else {
    // Older browsers remain functional without downloading every video at page load.
    var scheduled = false;
    var syncViewport = function () {
      scheduled = false;
      var height = window.innerHeight || document.documentElement.clientHeight;
      states.forEach(function (state) {
        var rect = state.video.getBoundingClientRect();
        state.near = rect.bottom > -300 && rect.top < height + 300;
        state.visible = rect.bottom > 0 && rect.top < height;
      });
      syncPreferences();
    };
    var requestSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(syncViewport);
    };
    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync, { passive: true });
    syncViewport();
  }

  document.addEventListener('visibilitychange', syncPreferences);
  if (motion) {
    if (motion.addEventListener) motion.addEventListener('change', syncPreferences);
    else if (motion.addListener) motion.addListener(syncPreferences);
  }
  if (connection && connection.addEventListener) connection.addEventListener('change', syncPreferences);
})();
